export { default as GTMPageView } from "./GTMPageView";
export { default as GTMViewItem } from "./GTMViewItem";
export { default as GTMViewCart } from "./GTMViewCart";
export { default as GTMPageViewHome } from "./GTMPageViewHome";
